import request from '@/utils/request.js'

export function foodList() {
  return request({
    url: '/food/list',
    method: 'get',
  })
}
